import { render, staticRenderFns } from "./Centered.vue?vue&type=template&id=b96f63fe&"
import script from "./Centered.vue?vue&type=script&lang=js&"
export * from "./Centered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports